"use client"

import React, { useState, useEffect } from 'react'
import { Cookie, X } from 'lucide-react'

export default function CookieConsent() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        // Check if user has already consented
        const hasConsented = localStorage.getItem('aurex_cookie_consent')
        if (!hasConsented) {
            setIsVisible(true)
        }
    }, [])

    const handleAcceptAll = () => {
        localStorage.setItem('aurex_cookie_consent', 'all')
        setIsVisible(false)
    }

    const handleAcceptEssential = () => {
        localStorage.setItem('aurex_cookie_consent', 'essential')
        setIsVisible(false)
    }

    if (!isVisible) return null

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[99999] p-4 pb-8 sm:p-6 pointer-events-none flex justify-center">
            <div className="bg-[#0a0a14]/95 border border-purple-500/20 backdrop-blur-xl rounded-2xl p-5 sm:p-6 max-w-4xl w-full pointer-events-auto flex flex-col sm:flex-row gap-6 items-start sm:items-center justify-between transition-all duration-500 animate-in slide-in-from-bottom-10 fade-in">
                <div className="flex gap-4 items-start sm:items-center">
                    <div className="bg-purple-500/10 p-3 rounded-full flex-shrink-0 hidden sm:block">
                        <Cookie className="w-6 h-6 text-purple-400" />
                    </div>
                    <div className="flex flex-col gap-2 pr-6 sm:pr-0">
                        <div className="flex items-center gap-2 sm:hidden">
                            <Cookie className="w-5 h-5 text-purple-400" />
                            <h3 className="text-white font-semibold font-poppins text-sm">We use cookies</h3>
                        </div>
                        <h3 className="text-white font-semibold font-poppins text-base hidden sm:block">We use cookies to improve your experience</h3>
                        <p className="text-gray-400 font-poppins text-xs sm:text-sm leading-relaxed max-w-2xl">
                            Aurex Hosting uses cookies to personalize content, ensure security, and analyze our traffic. By clicking &quot;Accept All&quot;, you consent to our use of cookies. 
                            <a href="/cookie-policy" className="text-purple-400 hover:text-purple-300 ml-1 underline decoration-purple-400/30 underline-offset-2 transition-colors">
                                Read our Cookie Policy.
                            </a>
                        </p>
                    </div>
                </div>
                
                <div className="flex flex-wrap sm:flex-nowrap items-center gap-3 w-full sm:w-auto">
                    <button 
                        onClick={handleAcceptEssential}
                        className="flex-1 sm:flex-none px-4 py-2.5 rounded-xl border border-white/10 text-gray-300 font-poppins text-sm font-medium hover:bg-white/5 hover:text-white transition-colors whitespace-nowrap"
                    >
                        Essential Only
                    </button>
                    <button 
                        onClick={handleAcceptAll}
                        className="flex-1 sm:flex-none px-5 py-2.5 rounded-xl bg-purple-600 hover:bg-purple-500 text-white font-poppins text-sm font-medium shadow-[0_0_20px_-5px_rgba(139,92,246,0.5)] transition-all whitespace-nowrap"
                    >
                        Accept All
                    </button>
                    <button 
                        onClick={handleAcceptEssential}
                        className="p-2 rounded-xl border border-transparent text-gray-500 hover:bg-white/5 hover:text-white transition-colors absolute top-4 right-4 sm:static sm:top-auto sm:right-auto sm:p-2.5"
                        aria-label="Close"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    )
}
